import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import MDInput from "../../materialDashboard/components/MDInput";
import MDBox from "../../materialDashboard/components/MDBox";


const SearchBox = ({table, placeholder}) => {
    const {t} = useTranslation(["components"]);
    const { pagination: {globalFilter} } = table.getState()

    // Search input value state
    const [search, setSearch] = useState(globalFilter);

    // Search input state handle
    const handleSearchChange = debounce((value) => {
        table.setGlobalFilter(value || undefined);
    }, 100);

    return <MDBox width="12rem">
        <MDInput
            placeholder={placeholder ?? t("dataTable.search")}
            value={search}
            size="small"
            fullWidth
            onChange={({ currentTarget }) => {
                setSearch(search);
                handleSearchChange(currentTarget.value);
            }}
        />
    </MDBox>
}

// A debounced function
function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

export default SearchBox;